
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accommodations/[slug]",
      function () {
        return require("private-next-pages/accommodations/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accommodations/[slug]"])
      });
    }
  